module.exports = __webpack_public_path__ + "media/images/realizacje/real18-0a205df8111726f40390a1f3363023eb.png";